import config from '../config';

const mainPath = `${config.CLOUD_STORAGE_URL}/${config.CLOUD_STORAGE_BUCKET}/${config.STATIC_DATA_FOLDER}`;

export const getUrlAvatar = (user, size = 35) => {
  if (user) {
    return `${mainPath}/avatars/${user?.id}?t=${new Date().getTime()}`;
  }
  return '';
};

export const getClassroomCover = (classroomId) => {
  if (classroomId) {
    return `${mainPath}/classroom-covers/${classroomId}?t=${new Date().getTime()}`;
  }
  return '';
};

export const getUrlBookCover = (book, size = 100) => {
  if (book) {
    // if (window.electronAPI && !navigator.onLine && book?.cover) {
    //   return book?.cover;
    // } else {
      const url = `${mainPath}/bookcovers/${book.id}?t=${new Date().getTime()}`;
      return url;
    // }
  }
  return '';
};
export const getDownloadUrlBookCover = (book) => {
  if (book) {
    return `${mainPath}/bookcovers/${book.id}`;
  }
  return '';
};

export const getUrlSkillScreenshot = (skillScreenshot) => {
  if (skillScreenshot) {
    // if (window.electronAPI && !navigator.onLine && skillScreenshot?.imageLink) {
    //   return skillScreenshot?.imageLink;
    // } else {
      return getDownloadUrlSkillScreenshot(skillScreenshot);
    // }
  }
  return '';
};

export const getDownloadUrlSkillScreenshot = (skillScreenshot) => {
  if (skillScreenshot) {
    return `${mainPath}/skillscreenshots/${skillScreenshot.id}`;
  }
  return '';
};

export const getUrlFeedbackScreenshot = (path) => {
  const url = `${config.STATIC_DATA_URL}/${path}`;
  return url;
};
export const getUrlTeacherVerificationImage = (path) => {
  const url = `${config.CLOUD_STORAGE_URL}/${config.CLOUD_STORAGE_BUCKET}/${path}`;
  return url;
};

export const getImageSize = (url, setSize) => {
  let img = new Image();
  img.addEventListener('load', function () {
    setSize({ width: this.naturalWidth, height: this.naturalHeight });
  });
  img.src = url;
};

export const defaultImage = (e, url: string) => {
  if ((e.target as any).src !== url) {
    (e.target as any).src = url;
  }
};

export const getUrlTeacherSkill = (path) => {
  if (path) {
    const url = `${config.STATIC_DATA_URL}/${path}`;
    return url;
  }
  return '';
};
export const getCloudStorageUrl = (path) => {
  if (path) {
    const url = `${config.CLOUD_STORAGE_URL}/${config.CLOUD_STORAGE_BUCKET}/${path}`;
    return url;
  }
  return '';
};
